"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartUpdateCreator = void 0;
var consts_1 = require("../consts");
var cartUpdateCreator = function (event) {
    var _a, _b, _c;
    var events = [];
    if (!((_c = (_b = (_a = event.eventData) === null || _a === void 0 ? void 0 : _a.cart) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.length))
        return events;
    events.push({
        action: "cart-update",
        event: "cart-update",
        eventInfo: "cart-update",
        cart: {
            currency: event.eventData.cart.currency || consts_1.NOT_AVAILABLE,
            product: event.eventData.cart.product.map(function (item) { return (__assign(__assign({}, item), { bundledProduct: item.bundledProduct || consts_1.NOT_AVAILABLE })); })
        }
    });
    return events;
};
exports.cartUpdateCreator = cartUpdateCreator;
